<!-- src/components/ui/CookieBanner.vue -->
<template>
	<transition name="fade-slide">
		<div v-if="visible" class="cookie-banner">
			<div class="cookie-banner__wrapper">
				<div class="cookie-banner__content">
					<div class="cookie-banner__text">
						Данный сайт использует файлы cookies с целью безопасности, а также
						оптимизации и персонализации содержимого сайта и рекламы, возможности
						использования функций социальных сетей и анализа трафика. Если Вы остаетесь
						на нашем сайте, это означает, что Вы не возражаете против использования этих
						технологий
						<a :href="cookiePolicyFile" target="_blank" rel="noopener">
							Подробности.
						</a>
					</div>
					<div class="cookie-banner__btn">
						<button type="button" class="btn _btn-primary" @click="accept">
							<div class="btn__text">Принять</div>
							<svg
								class="btn__shadow"
								preserveAspectRatio="none"
								viewBox="0 0 313 140"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M313 20.0118L293 0L293 120L313 140L313 20.0118Z"
									fill="#925566"
								/>
								<path d="M20 140L0 120H293L313 140H20Z" fill="#BA5F79" />
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { hasConsent, giveConsent } from '@/utils/cookieConsent.js'
import { initYandexMetrika } from '@/utils/metrika.js'
import { eventBus } from '@/utils/eventBus.js'

const cookiePolicyFile = '/docs/cookie-policy.pdf'

const onPreloaderFinished = async () => {
	await new Promise((res) => setTimeout(res, 3000))
	visible.value = true
}

const visible = ref(false)

onMounted(async () => {
	if (hasConsent()) {
		initYandexMetrika()
		return
	}

	await new Promise((resolve) => setTimeout(resolve, 3000))
	visible.value = true
})

onUnmounted(() => {
	eventBus.off('preloader-finished', onPreloaderFinished)
})

function accept() {
	giveConsent()
	initYandexMetrika()
	visible.value = false
}
</script>

<style scoped lang="scss">
/* Fade animation */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

// cookie
.fade-slide-enter-from {
	opacity: 0;
	transform: translateY(100%);
}
.fade-slide-enter-active {
	transition: all 0.5s ease;
}
.fade-slide-enter-to {
	opacity: 1;
	transform: translateY(0);
}

.fade-slide-leave-from {
	opacity: 1;
	transform: translateY(0);
}
.fade-slide-leave-active {
	transition: all 0.5s ease;
}
.fade-slide-leave-to {
	opacity: 0;
	transform: translateY(100%);
}

.cookie-banner {
	position: fixed;
	pointer-events: none;
	top: 0;
	left: 0;
	z-index: 1000;
	width: 100%;
	height: 100svh;
	max-height: 100svh;
	overflow: auto;

	&__container {
		height: 100%;
		width: 100%;
	}

	&__wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
	}

	// .cookie-banner__content
	&__content {
		pointer-events: all;
		width: 100%;
		width: 100%;
		padding: 2.6rem 8rem;
		border-radius: 3.2rem 3.2rem 0 0;
		background: var(--bg-color);
		display: flex;
		align-items: center;
		gap: 2.6rem;

		@media (max-width: 991.98px) {
			flex-direction: column;
			padding: 2rem;
			gap: 2rem;
		}

		.btn {
			flex-shrink: 0;
			padding-bottom: 1rem;
			padding-right: 1.2rem;
		}

		.btn__text {
			padding: 2rem 4rem;
			font-size: 2rem;
		}
	}

	// .cookie-banner__text
	&__text {
		font-weight: 600;
		font-size: 1.6rem;
		// line-height: 2.1rem;
		line-height: 130%;
		color: #fff;

		@media (max-width: 991.98px) {
			font-size: 1.4rem;
		}

		p {
			font-weight: inherit;
			font-size: inherit;
			line-height: inherit;
		}

		a {
			text-decoration: underline;
			text-decoration-skip-ink: none;

			@media (any-hover: hover) {
				&:hover {
					text-decoration: none;
				}
			}
		}
	}
}
</style>
